import { render } from "./ChangeOtpChannelForm.vue?vue&type=template&id=15b5a792"
import script from "./ChangeOtpChannelForm.vue?vue&type=script&lang=js"
export * from "./ChangeOtpChannelForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__